/**
 *
 * CbPopover
 *
 */

import React from 'react';
import uuid from 'uuid';
import { Popover, PopoverHeader, PopoverBody, PopoverProps } from 'reactstrap';
// import styled from 'styled-components';

import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { Boundary } from 'popper.js';

export interface CbPopoverProps {
  targetWrapperTag?: string | React.ComponentClass;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  targetWrapperProps?: { className?: string; [key: string]: any };
  placement?: PopoverProps['placement'];
  headerText?: MessageDescriptor;
  bodyText?: MessageDescriptor;
  body?: JSX.Element | string;
  boundariesElement?: Boundary | Element;
}

interface State {
  popoverOpen: boolean;
}

const WithPopover = (WrappedComponent: React.ComponentType, { openOnHover }: { openOnHover?: boolean } = {}) => {
  return class CbPopover extends React.Component<CbPopoverProps, State> {
    static defaultProps: Partial<CbPopoverProps> = {
      placement: 'right',
      targetWrapperTag: 'span',
      targetWrapperProps: { className: '' },
    };

    state: State = {
      popoverOpen: false,
    };

    popoverId = `helpme-${uuid()}`;

    render() {
      const {
        headerText,
        bodyText,
        body,
        placement,
        boundariesElement,
        targetWrapperTag: TargetWrapper,
        targetWrapperProps: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className: targetWrapperClassName,
          ...otherTargetWrapperProps
        },
      } = this.props;
      const hoverControls = openOnHover
        ? {
            onMouseOver: () => {
              this.setState({ popoverOpen: true });
            },
            onMouseOut: () => {
              this.setState({ popoverOpen: false });
            },
          }
        : {};
      return (
        <React.Fragment>
          {/* 
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore */}
          <TargetWrapper
            id={this.popoverId}
            onClick={this.toggle}
            className={`${targetWrapperClassName} c-pointer`}
            {...hoverControls}
            {...otherTargetWrapperProps}
          >
            <WrappedComponent />
          </TargetWrapper>
          <Popover
            placement={placement}
            isOpen={this.state.popoverOpen}
            target={this.popoverId}
            trigger="legacy"
            boundariesElement={boundariesElement}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore reactstrap type is wrong
            toggle={this.toggle}
          >
            {headerText && (
              <PopoverHeader>
                <FormattedMessage {...headerText} />
              </PopoverHeader>
            )}
            <PopoverBody>
              {bodyText && <FormattedMessage {...bodyText} />}
              {body && body}
            </PopoverBody>
          </Popover>
        </React.Fragment>
      );
    }

    toggle = (e: React.MouseEvent) => {
      e.stopPropagation(); // allow help text in a button without triggering button
      this.setState({
        popoverOpen: !this.state.popoverOpen,
      });
    };
  };
};

export default WithPopover;
